/*
 * Login Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    GET_USER_PAYMENT_DETAILS,
    GET_USER_PAYMENT_DETAILS_FAILURE,
    GET_USER_PAYMENT_DETAILS_SUCCESS,
} from '../constants';

/**
 * Fetches the login details of the user if already in DB
 *
 * @param  {data} data in the form
 *
 * @return {object}    An action object with a type of FETCH_LOGIN_DETAILS
 */
export function login(data) {
    console.log('login action :>> ', data);
    return {
        type: LOGIN,
        data,
    };
}

export function loginSuccess(data) {
    return {
        type: LOGIN_SUCCESS,
        data,
    };
}

export function loginFailure(data) {
    return {
        type: LOGIN_FAILURE,
        data,
    };
}

export function getUserPaymentDetails(data) {
    return {
        type: GET_USER_PAYMENT_DETAILS,
        data,
    };
}

export function getUserPaymentDetailsFailure(data) {
    return {
        type: GET_USER_PAYMENT_DETAILS_FAILURE,
        data,
    };
}

export function getUserPaymentDetailsSuccess(data) {
    return {
        type: GET_USER_PAYMENT_DETAILS_SUCCESS,
        data,
    };
}

